import { render, staticRenderFns } from "./ShowAdvert.vue?vue&type=template&id=4a0b72a6&scoped=true&"
import script from "./ShowAdvert.vue?vue&type=script&lang=js&"
export * from "./ShowAdvert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0b72a6",
  null
  
)

export default component.exports